<template>
  <div class="row modal-content">
    <page-header
      class="mb-6"
      :header-title="$t('IMPORT_WIZARD.STEP_1.TITLE')"
      :header-content="$t('IMPORT_WIZARD.STEP_1.DESC')"
    />
    <div class="medium-12 columns">
      <label>
        <span>{{ $t('IMPORT_WIZARD.STEP_1.LABEL') }}</span>
        <input
          id="file"
          ref="file"
          type="file"
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          @change="handleFileUpload"
        />
        <span v-if="error" class="text-red-500">
          {{ error }}
        </span>
      </label>
    </div>
  </div>
</template>

<script>
import { checkFileSizeLimit } from 'shared/helpers/FileHelper';
import PageHeader from 'dashboard/routes/dashboard/settings/SettingsSubPageHeader.vue';
export default {
  components: { PageHeader },
  data: () => ({
    error: '',
  }),
  methods: {
    handleFileUpload(event) {
      this.$store.commit('importWizard/CLEAR_MAPPING');
      this.$store.commit('importWizard/CLEAR_FILE');
      this.error = '';
      const file = event.target.files[0];
      if (!file) return;

      if (!checkFileSizeLimit(file, 10)) {
        this.error = this.$t('IMPORT_WIZARD.STEP_1.ERROR.SIZE');
        return;
      }
      if (
        file.type !==
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      ) {
        this.error = this.$t('IMPORT_WIZARD.STEP_1.ERROR.FORMAT');
        return;
      }

      const reader = new FileReader();
      reader.onload = e => {
        this.$store.commit('importWizard/SET_FILE', {
          resource: file,
          thumb: e.target.result,
        });
        this.$store.commit('importWizard/CLEAR_MAPPING');
      };

      reader.readAsBinaryString(file);
    },
  },
};
</script>

<style scoped lang="scss"></style>
